import * as React from 'react';
import { SVGProps } from 'react';
import { useStyledTheme } from '../../../styling';

export function WarningIcon(props: SVGProps<SVGSVGElement>) {
  const theme = useStyledTheme();

  const { fill = theme.colours.warning[1], stroke = '#ffffff' } = props;

  return (
    <svg
      style={{ width: 'inherit', height: 'inherit' }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.82007 2.14373C7.32 1.19395 8.68 1.19395 9.17987 2.14373L14.7423 12.7123C15.2096 13.6002 14.5657 14.6667 13.5624 14.6667H2.43757C1.43422 14.6667 0.790374 13.6002 1.25767 12.7123L6.82007 2.14373Z" fill={stroke} />
      <path d="M7.99998 9.33333C7.63178 9.33333 7.33331 9.03487 7.33331 8.66667V6.66667C7.33331 6.29848 7.63178 6 7.99998 6C8.36818 6 8.66665 6.29848 8.66665 6.66667V8.66667C8.66665 9.03487 8.36818 9.33333 7.99998 9.33333Z" fill={fill} />
      <path d="M7 11C7 10.4477 7.44773 10 8 10C8.55227 10 9 10.4477 9 11C9 11.5523 8.55227 12 8 12C7.44773 12 7 11.5523 7 11Z" fill={fill} />
    </svg>
  );
}
